/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { DrawerContext, InlineEditableField } from '@AMIEWEB/Common';
import { addYears } from 'date-fns';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import moment from 'moment';
import { missingField } from 'app/constants';
import { pageAttributesActions } from '../../store/placementPageAttributes.redux';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { placementDetailsAction } from 'store/redux-store/placement-details/slice';


type ComplianceStatusProgressDocDeadlineProps = {
    id: string;
    docDeadline: string;
    maxWidth?: number | undefined;
}

export default function ComplianceStatusProgressDocDeadline(
    complianceStatusProgressDocDeadlineProps: ComplianceStatusProgressDocDeadlineProps) {

    const { id, docDeadline, maxWidth } = complianceStatusProgressDocDeadlineProps;
    const dispatch = useDispatch();
    const { setPopperOpen } = useContext(DrawerContext);
    const formMethods = useForm({ defaultValues: { docDeadline: docDeadline } });
    const params = useParams<{ placementId: string }>();
    const {
        control,
        watch,
        setValue
    } = formMethods;

    const value = watch('docDeadline');

    useEffect(() => {
        setValue('docDeadline', docDeadline);
        return () => {
            setPopperOpen?.('docDeadline', false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docDeadline]);

    return (
        <FormProvider {...formMethods}>
            <form id="csp-doc-deadline-form" autoComplete="off" noValidate={true}>
                <Controller
                    control={control}
                    name={'docDeadline'}
                    render={({ field: { onChange, ...rest } }) => {
                        const docDeadlineDate = moment(value);
                        return (
                            <InlineEditableField
                                {...rest}
                                fullWidth
                                id={id}
                                maxWidth={maxWidth}
                                minWidth={maxWidth}
                                inputProps={{
                                    size: 'inline',
                                    variant: 'outlined',
                                    initialDateRange: {
                                        startDate: docDeadlineDate.isValid() ? new Date(value) : undefined,
                                        endDate: docDeadlineDate.isValid() ? new Date(value) : undefined,
                                        useLabelAsValue: true,
                                    },
                                    maxDate: addYears(new Date(), 20),
                                    quickSelect: false,
                                    disablePortal: true,
                                    actionBar: false,
                                    single: true,
                                    onOpen: open => setPopperOpen?.('docDeadlineDate', open),
                                    useMaxWidth: !!maxWidth,
                                }}
                                label={docDeadlineDate.isValid() ? docDeadlineDate.format('MM/DD/YYYY') : missingField}
                                Control={DateRangePicker}
                                onChange={(newValue) => {
                                    if (newValue.startDate !== undefined) {
                                        const newDate = moment(newValue.startDate);
                                        const setTo = newDate.isValid() ? moment(newDate).format('MM/DD/YYYY') : null;
                                        onChange(setTo);
                                        dispatch(placementDetailsAction.saveComplianceStatusDocDeadline({
                                            docDeadline: setTo,
                                            placementId: parseInt(params.placementId)
                                        }));
                                    } else {
                                        onChange(null);
                                        dispatch(placementDetailsAction.saveComplianceStatusDocDeadline({
                                            docDeadline: '',
                                            placementId: parseInt(params.placementId)
                                        }));
                                    }
                                }}
                                tooltipText={'Doc Deadline'}
                                useWidth={!!maxWidth}
                                setCurrentFocus={state => dispatch(pageAttributesActions.setCurrentFocus(state !== null ? id : null))}
                            />
                        )
                    }
                    }
                />
            </form>
        </FormProvider>
    )
}